import { useOrganization } from "./OrganizationContext";
import { useAuth } from "context/Auth";
import { Grid, Typography } from "@mui/material";
import TemplateSelect from "components/TemplateSelect";
import { ITemplate } from "types/templates";

export default function OrganizationTemplates() {
  const { organization, setOrganization } = useOrganization();
  const { user } = useAuth();

  const handleTemplateChange = (type: string) => (template: ITemplate | null) => {
    setOrganization({
      ...organization,
      templates: {
        ...organization?.templates,
        [type]: template
      }
    });
  };

  return (
    <div className="p-6">
      <Typography variant="h4" className="mb-6">
        Default Templates
      </Typography>

      <Grid container spacing={3} direction="column">
        <Grid item>
          <TemplateSelect
            value={organization?.templates?.eventAnnouncement}
            onChange={handleTemplateChange("eventAnnouncement")}
            label="Event Announcement Template"
          />
        </Grid>

        <Grid item>
          <TemplateSelect
            value={organization?.templates?.eventInvitation}
            onChange={handleTemplateChange("eventInvitation")}
            label="Event Invitation Template"
          />
        </Grid>

        <Grid item>
          <TemplateSelect
            value={organization?.templates?.rsvpConfirmation}
            onChange={handleTemplateChange("rsvpConfirmation")}
            label="RSVP Confirmation Template"
          />
        </Grid>

        <Grid item>
          <TemplateSelect
            value={organization?.templates?.ticketsGenerated}
            onChange={handleTemplateChange("ticketsGenerated")}
            label="Tickets Generated Template"
          />
        </Grid>

        <Grid item>
          <TemplateSelect
            value={organization?.templates?.organizationInvitation}
            onChange={handleTemplateChange("organizationInvitation")}
            label="Organization Invitation Template"
          />
        </Grid>
      </Grid>
    </div>
  );
}